import { render, staticRenderFns } from "./AddBarTDWidget.vue?vue&type=template&id=6faec752"
import script from "./AddBarTDWidget.vue?vue&type=script&lang=js"
export * from "./AddBarTDWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports